import axios from "axios";

// =====================================================
// ✅ Base URL for your Strapi backend 
// =====================================================
const api = axios.create({
  baseURL: "https://backend.bharatpacks.com", // ⚠️ change if deployed
  headers: {
    "Content-Type": "application/json",
  },
});

// =====================================================
// ✅ CREATE a new Quotation  
// =====================================================
export const saveQuotation = async (payload) => {
  try {
    console.log("📤 Sending quotation payload:", payload);
    const { data } = await api.post("/quotations", { data: payload }); // Strapi expects { data: {...} }
    console.log("✅ Quotation saved:", data);
    return data.data;
  } catch (error) {
    console.error("❌ Error saving quotation:", error.response?.data || error.message);
    throw new Error(
      error.response?.data?.error?.message || "Failed to save quotation"
    );
  }
};

// =====================================================
// ✅ FETCH all Quotations
// =====================================================
export const fetchQuotations = async () => {
  try {
    const { data } = await api.get("/quotations?populate=*&sort=createdAt:desc");
    return data.data || [];
  } catch (error) {
    console.error("❌ Error fetching quotations:", error.response?.data || error.message);
    throw new Error("Failed to fetch quotations");
  }
};

// =====================================================
// ✅ FETCH a single Quotation by ID
// =====================================================
export const fetchQuotationById = async (id) => {
  try {
    const { data } = await api.get(`/quotations/${id}?populate=*`);
    if (!data || !data.data) throw new Error("Quotation not found");
    return data.data;
  } catch (error) {
    console.error("❌ Error fetching quotation:", error.response?.data || error.message);
    if (error.response?.status === 404) {
      throw new Error("Quotation not found (404)");
    }
    throw new Error("Failed to fetch quotation details");
  }
};

// =====================================================
// ✅ UPDATE an existing Quotation
// =====================================================
export const updateQuotation = async (id, payload) => {
  try {
    console.log("✏️ Updating quotation ID:", id, "Payload:", payload);
    const { data } = await api.put(`/quotations/${id}`, { data: payload });
    console.log("✅ Quotation updated:", data);
    return data.data;
  } catch (error) {
    console.error("❌ Error updating quotation:", error.response?.data || error.message);
    if (error.response) {
      console.error("Status:", error.response.status);
      console.error("Payload sent:", payload);
    }
    throw new Error(
      error.response?.data?.error?.message || "Failed to update quotation"
    );
  }
};

// =====================================================
// ✅ DELETE a Quotation
// =====================================================
export const deleteQuotation = async (id) => {
  try {
    const { data } = await api.delete(`/quotations/${id}`);
    console.log("🗑️ Quotation deleted:", data);
    return data;
  } catch (error) {
    console.error("❌ Error deleting quotation:", error.response?.data || error.message);
    throw new Error("Failed to delete quotation");
  }
};

// =====================================================
// ✅ FETCH next Quotation Number (auto-increment by FY)
// =====================================================
export const fetchNextQuotationNo = async (financialYear) => {
  try {
    const params = new URLSearchParams();
    params.append("filters[financialYear][$eq]", financialYear);
    params.append("sort[0]", "quotationNo:desc");
    params.append("pagination[limit]", 1);
    params.append("fields[0]", "quotationNo");

    const { data } = await api.get(`/quotations?${params.toString()}`);
    const lastQuotation = data.data?.[0];

    if (lastQuotation?.attributes?.quotationNo) {
      return lastQuotation.attributes.quotationNo + 1;
    }
    return 1; // start new FY sequence
  } catch (error) {
    console.error("❌ Error fetching next quotation number:", error.response?.data || error.message);
    throw new Error("Failed to fetch next quotation number");
  }
};

// =====================================================
// ✅ Export axios instance
// =====================================================
export default api;
